export default __webpack_public_path__ + "static/media/Mathematiques.9b071a44.png";